import React from 'react'
import { useSelector } from 'react-redux'
import lookup from 'country-code-lookup'
import { AMBASSADORS_PAGE_STATIC_KEY } from '../../../../services/ambassadors/index'
import { selectAmbassadorDetailsData, selectAmbassadorDetailsError } from '../../../../services/ambassadors/selectors'
import {
  getDateTime,
  getFormattedLocaleDate,
} from '../../../../services/date-time/index'
import { selectStaticTextByKey } from '../../../../services/static-text/selectors'
import { selectPrimaryLanguage } from '../../../../services/user/selectors'

const PartnerDetailsTab = () => {
  const ambassadorDetailsData = useSelector(selectAmbassadorDetailsData)
  const ambassadorDetailsError = useSelector(selectAmbassadorDetailsError)
  const userLanguage = useSelector(selectPrimaryLanguage)
  const staticText = useSelector(selectStaticTextByKey(AMBASSADORS_PAGE_STATIC_KEY))

  if (ambassadorDetailsError) {
    return (
      <div className="partner-page__detail-tab">
        <div className="ambassadors-page__error">
          {staticText.get('somethingWentWrong')}
        </div>
      </div>
    )
  }

  const residenceCountry = ambassadorDetailsData.get('residenceCountry')

  return (
    <div className="partner-page__detail-tab">
      <div className="partner-page__detail-tab--item">
        <div className="partner-page__detail-tab--item-label">{staticText.get('businessName', '')}</div>
        <div>{ambassadorDetailsData.get('businessName', '')}</div>
      </div>
      <div className="partner-page__detail-tab--item">
        <div className="partner-page__detail-tab--item-label">{staticText.get('gaiaEmail', '')}</div>
        <div>{ambassadorDetailsData.get('gaiaEmail', '')}</div>
      </div>
      <div className="partner-page__detail-tab--item">
        <div className="partner-page__detail-tab--item-label">{staticText.get('active', '')}</div>
        <div>{ambassadorDetailsData.get('isActive', '') ? staticText.get('campaignDetailsActiveYes', '') : staticText.get('campaignDetailsActiveNo', '')}</div>
      </div>
      <div className="partner-page__detail-tab--item">
        <div className="partner-page__detail-tab--item-label">{staticText.get('name', '')}</div>
        <div>{ambassadorDetailsData.get('name', '')}</div>
      </div>
      <div className="partner-page__detail-tab--item">
        <div className="partner-page__detail-tab--item-label">{staticText.get('utmMedium', '')}</div>
        <div>{ambassadorDetailsData.get('utmMedium', '')}</div>
      </div>
      <div className="partner-page__detail-tab--item">
        <div className="partner-page__detail-tab--item-label">{staticText.get('residenceCountry', '')}</div>
        <div>
          {residenceCountry ? lookup.byIso(residenceCountry).country : (<span>&mdash;</span>)}
        </div>
      </div>
      <div className="partner-page__detail-tab--item">
        <div className="partner-page__detail-tab--item-label">{staticText.get('relationship', '')}</div>
        <div>{ambassadorDetailsData.get('relationship', '')}</div>
      </div>
      <div className="partner-page__detail-tab--item">
        <div className="partner-page__detail-tab--item-label">{staticText.get('ripple1Percentage', '')}</div>
        <div>{ambassadorDetailsData.get('ripple1Percentage', '')}</div>
      </div>
      <div className="partner-page__detail-tab--item">
        <div className="partner-page__detail-tab--item-label">{staticText.get('payoutCurrency', '')}</div>
        <div>{ambassadorDetailsData.get('payoutCurrency', '')}</div>
      </div>
      <div className="partner-page__detail-tab--item">
        <div className="partner-page__detail-tab--item-label">{staticText.get('contactEmail', '')}</div>
        <div>{ambassadorDetailsData.get('contactEmail', '')}</div>
      </div>
      <div className="partner-page__detail-tab--item partner-page__detail-tab--item-start-date">
        <div className="partner-page__detail-tab--item-label">{staticText.get('ambassadorStartedDate', '')}</div>
        <div>{getFormattedLocaleDate(getDateTime(ambassadorDetailsData.get('startedAt', '')), userLanguage)}</div>
      </div>
      <div className="partner-page__detail-tab--item ">
        <div className="partner-page__detail-tab--item-label">{staticText.get('relationshipOwner', '')}</div>
        <div>{ambassadorDetailsData.getIn(['relationshipOwner', 'fullName'], 'Unassigned')}</div>
      </div>
    </div>
  )
}

export default PartnerDetailsTab
